var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[(_vm.$vuetify.breakpoint.smAndUp)?_c('w-desktop'):_c('w-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }